<template>
  <div>
    <div class="col-xs-12 col-md-6 col-lg-4">
      <div class="hpanel hblue">
        <div class="panel-body">
          <h3>{{plan.productObject.name}}</h3>
          <template v-if="plan.productObject.name === 'Silver'">
            <div style="margin-bottom: 15px;font-weight: bold">Perfect for trying out the full service and for occasional use</div>
            <ul>
              <li class="m-b">Save, organise, share, bookmark your findings</li>
              <li class="m-b">Access more advanced content (Science, Patents, Companies)</li>
              <li class="m-b">Design step-by-step innovation projects</li>
              <li class="m-b">Collaborate with colleagues and partners</li>
            </ul>
          </template>
          <template v-else-if="plan.productObject.name === 'Diamond'">
            <div style="margin-bottom: 15px;font-weight: bold">Our best value plan for a full Open Innovation Broker plan</div>
            <ul>
              <li class="m-b">Benefit from additional search credits and project storage</li>
              <li class="m-b">Send personalised emails to experts and companies that matter to your innovation</li>
              <li class="m-b">Keep record of your interactions</li>
            </ul>
          </template>
          <template v-else-if="plan.productObject.name === 'Basic'">
            <div style="margin-bottom: 15px;font-weight: bold">Our best value plan for a full service for Individuals and SMEs</div>
            <ul>
              <li class="m-b">Smart explore technology and science</li>
              <li class="m-b">Promote your own or your organisation's expertise</li>
              <li class="m-b">Pinpoint leading-edge experts among 10,000,000</li>
              <li class="m-b">Monitor specific keywords and experts</li>
            </ul>
          </template>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-md-6 col-lg-8">
      <div class="hpanel">
        <div class="panel-body">
          <div class="row" style="margin-top: 25px">
            <template v-if="plan.productObject.name !== 'Basic'">

              <div class="col-xs-12">
                <h5 style="font-size: 18px" v-if="trial !== true">You are about to subscribe to a {{plan.productObject.name}} plan ({{typeof plan.annually !== 'undefined' ? (plan.annually * 12) : plan.monthly | toCurrency}}/{{plan.interval}})</h5>
                <h5  v-else>Try the {{plan.productObject.name}} plan,<b><u> {{trialPeriodDays}} days free</u></b> then {{typeof plan.annually !== 'undefined' ? (plan.annually * 12) : plan.monthly | toCurrency}}/{{plan.interval}}  <i>(No money will be taken from your card today)</i></h5>
              </div>
              <div class="col-xs-12 m-t" >
                <template v-if="trial !== true">
                  All subscription are <b><u> non-binding beyond the period. You can return to a free Basic plan at any time before the next invoicing period</u></b>:
                </template>
                <template v-else>
                  All subscription are <b><u> non-binding beyond the period. You can terminate your trial at any time before the first invoicing period,</u></b> which is the {{ new Date() | moment('add', trialPeriodDays + ' days') | moment('LL')}}:
                </template>
                <br><br>
                <ul style="font-weight: normal">
                  <li>By downgrading to a free Basic plan</li>
                  <li>By simply unchecking the renewal check box in your profile</li>
                </ul>
              </div>
              <template v-if="trial === true">
                <div  class="col-xs-12 m-t">
                  The symbol <i class="fa fa-lock text-warning"></i> in the next page indicates that <b><u>your transaction is secure</u></b>. You can proceed with your payment with confidence.
                </div>
              </template>
              <div class="col-xs-12 text-center m-t">
                <button v-if="trial !== true" class="btn btn-info" @click="$emit('input', false)">Proceed to payment</button>
                <button v-else class="btn btn-info" @click="$emit('input', false)">Continue</button>
              </div>
              <div class="col-xs-12 m-t-md" style="">
                You can contact us for any question via the chat (bottom right).
              </div>
            </template>
            <template v-else>
              <div class="col-xs-12">
                <h5 style="font-size: 18px" v-if="subscription">
                  <template v-if="subscription.trial_end === subscription.current_period_end">
                    Your plan will revert to a free Basic plan at the end of your free trial, ie on {{subscription.trial_end | moment('DD/MM/YYYY')}}
                  </template>
                  <template v-else>
                    Your plan will revert to a free Basic plan at the end of your subscription period, ie on {{subscription.current_period_end | moment('DD/MM/YYYY')}}.
                  </template>
                </h5>
              </div>
              <div class="col-xs-12 m-t-lg" style="font-weight: bold">
                Your projects data will always be accessible. You will be able to re-subscribe to a Silver or Diamond plan at any time.
              </div>
              <div class="col-xs-12 text-center" style="margin-top: 50px">
                <button class="btn btn-info" @click="$emit('input', false)">Proceed</button>
              </div>
            </template>

            <div class="col-xs-12" style="margin-top: 25px">
              Our general <a href="https://www.idexlab.com/wp-content/uploads/2019/04/terms-of-use-idexlab-open-innovation-platform-.pdf" target="_blank"> terms and conditions of sale</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SummaryPlan',
  props: {
    value: {},
    plan: {
      required: true,
      default: null
    }
  },
  data () {
    return {
      subscription: null,
      trial: localStorage.getItem('trial') === 'true',
      trialPeriodDays: process.env.TRIAL_PERIOD_DAYS
    }
  },
  methods: {
    getResources: function () {
      this.axios.get('/payment/subscription').then((response) => {
        this.subscription = response.data
      })
    }
  },
  beforeMount () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/plan/SummaryPlan.vue